import * as React from 'react';
const SvgError = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={240}
    height={240}
    fill="none"
    viewBox="0 0 240 240"
    {...props}
  >
    <path
      fill="#FFECEB"
      d="M120 204c46.39 0 84-37.61 84-84s-37.61-84-84-84-84 37.61-84 84 37.61 84 84 84"
    />
    <path
      fill="#F77167"
      d="M170.24 199.45c.53-2.21 3.67-2.21 4.21 0l.71 2.94c.19.79.81 1.41 1.6 1.6l2.93.71c2.21.53 2.21 3.68 0 4.21l-2.93.71c-.79.19-1.41.81-1.6 1.6l-.71 2.94c-.53 2.21-3.67 2.21-4.21 0l-.71-2.94a2.17 2.17 0 0 0-1.6-1.6l-2.93-.71c-2.21-.53-2.21-3.68 0-4.21l2.93-.71a2.17 2.17 0 0 0 1.6-1.6z"
    />
    <path
      fill="#FF988F"
      fillRule="evenodd"
      d="M153.35 41.7a1.9 1.9 0 1 0 .002-3.798 1.9 1.9 0 0 0-.002 3.798m0 2.6c2.49 0 4.5-2.01 4.5-4.5s-2.01-4.5-4.5-4.5-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5"
      clipRule="evenodd"
    />
    <path
      fill="#FFD4D2"
      fillRule="evenodd"
      d="M211.45 148.89a1.9 1.9 0 1 0 .002-3.798 1.9 1.9 0 0 0-.002 3.798m0 2.6c2.49 0 4.5-2.01 4.5-4.5s-2.01-4.5-4.5-4.5-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5"
      clipRule="evenodd"
    />
    <path
      fill="#F77167"
      d="M66.95 24.06c.5-2.09 3.48-2.09 3.98 0l.76 3.17c.18.75.76 1.33 1.51 1.51l3.17.76c2.09.5 2.09 3.48 0 3.98l-3.17.76c-.75.18-1.33.76-1.51 1.51l-.76 3.17c-.5 2.09-3.48 2.09-3.98 0l-.76-3.17c-.18-.75-.76-1.33-1.51-1.51l-3.17-.76c-2.09-.5-2.09-3.48 0-3.98l3.17-.76c.75-.18 1.33-.76 1.51-1.51z"
    />
    <path
      fill="#FF988F"
      d="M195.26 32.47c1.27-.54 2.65.51 2.48 1.88l-.94 7.57a1.793 1.793 0 0 1-2.87 1.21l-6.07-4.61c-1.1-.84-.89-2.56.38-3.1l7.01-2.97zM126.26 198.47c1.27-.54 2.65.51 2.48 1.88l-.94 7.57a1.793 1.793 0 0 1-2.87 1.21l-6.07-4.61c-1.1-.84-.89-2.56.38-3.1l7.01-2.97zM32.91 122.75c.4-1.32 2.09-1.72 3.04-.7l5.22 5.57c.95 1.01.45 2.67-.9 2.98l-7.42 1.72c-1.35.31-2.54-.95-2.13-2.28l2.21-7.29z"
    />
    <path
      fill="#F77167"
      d="m110.59 41.04-71.7 124.19c-4.18 7.25 1.05 16.31 9.41 16.31h143.41c8.37 0 13.6-9.06 9.41-16.31l-71.7-124.19c-4.18-7.25-14.64-7.25-18.83 0"
    />
    <path
      fill="#fff"
      d="M128.32 150.98c0 2.04-1.83 3.64-4.16 3.64h-8.32c-2.33 0-4.16-1.6-4.16-3.64v-7.28c0-2.04 1.83-3.64 4.16-3.64h8.32c2.33 0 4.16 1.6 4.16 3.64zm0-22.87c0 2.04-1.83 3.64-4.16 3.64h-8.32c-2.33 0-4.16-1.6-4.16-3.64V91.73c0-2.04 1.83-3.64 4.16-3.64h8.32c2.33 0 4.16 1.6 4.16 3.64z"
    />
    <path
      fill="#FFD4D2"
      d="M211.29 103.5c0 2.55-.92 5.01-2.6 6.92a10.47 10.47 0 0 1-7.92 3.58H165.8a13.218 13.218 0 0 1-10.39-5.02 13.183 13.183 0 0 1 1.14-17.61c2.33-2.28 5.43-3.61 8.69-3.75 1.69-3.66 4.53-6.68 8.08-8.59 3.56-1.91 7.64-2.62 11.63-2.01s7.68 2.49 10.5 5.38c2.82 2.88 4.63 6.6 5.16 10.6h.16c1.38 0 2.75.27 4.03.79 1.28.53 2.44 1.3 3.42 2.27.98.98 1.75 2.13 2.28 3.41.53 1.27.8 2.64.8 4.02zM26.7 73.99c0 3.42 2.18 6.61 5.76 7.71.72.22 1.49.3 2.24.3h26.49c2.61-.01 5.11-1.05 6.98-2.89 1.86-1.84 2.93-4.33 2.99-6.95s-.91-5.16-2.69-7.07a10 10 0 0 0-6.85-3.18 14.2 14.2 0 0 0-6.13-6.52 14.08 14.08 0 0 0-8.8-1.52c-3.02.46-5.81 1.89-7.95 4.08A14.16 14.16 0 0 0 34.82 66h-.13c-.74 0-1.48.07-2.18.29-3.6 1.09-5.79 4.28-5.8 7.7zM35.59 198.51c0 2.54.92 5 2.6 6.91s3.99 3.15 6.51 3.48c.46.06.92.1 1.38.1h34.89c.76 0 1.52-.06 2.27-.19 3.23-.54 6.14-2.25 8.17-4.81a13.2 13.2 0 0 0 2.83-9.05 13.22 13.22 0 0 0-3.97-8.61 13.2 13.2 0 0 0-8.72-3.72 18.5 18.5 0 0 0-8.07-8.57 18.62 18.62 0 0 0-11.6-2.01 18.6 18.6 0 0 0-10.48 5.37 18.55 18.55 0 0 0-5.15 10.58h-.16c-1.38 0-2.75.27-4.02.8s-2.43 1.3-3.41 2.28c-.97.98-1.75 2.13-2.27 3.41-.53 1.28-.8 2.64-.79 4.02z"
    />
  </svg>
);
export default SvgError;
